import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '~environment';
import { HttpRequestService } from './HttpRequestService';

@Injectable({
  providedIn: 'root'
})
export class TransaccionService {

  private readonly triidyServiceUrl = `${environment.apiTriidyUrl}`;
  private readonly triidyServiceUrlRest = `${environment.apiTriidyUrlRest}/api`;

  constructor(private http: HttpClient,
    private httpRequestService: HttpRequestService) { }

  getStatus(tipo, referencia): Observable<any[]> {
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      token,
      tipo,
      referencia
    });
    return this.http
      .get<any[]>(`${this.triidyServiceUrl}/GetStatus`, {
        params,
      })
      .pipe(
        map((respuesta) => {
          //console.log("Este usuario es: " + respuesta[0].response);
          return respuesta;
        })
      );
  }
}
